import * as Dialog from "@radix-ui/react-dialog";
import React from "react";

import { FinancingModalHeader } from "../FinancingModalHeader";

import styles from "./index.module.scss";

export const FinancingRoot = Dialog.Root;

export const FinancingPortalClose = Dialog.Close;

export const FinancingPortal = (
    props: React.PropsWithChildren<{
        title: string;
    }>,
): React.JSX.Element => {
    return (
        <Dialog.Portal>
            <Dialog.Overlay className={styles.overlay} />
            <Dialog.Content
                className={styles.container}
                aria-describedby={undefined}
            >
                <FinancingModalHeader title={props.title} />
                <div className={styles.wrapper}>{props.children}</div>
            </Dialog.Content>
        </Dialog.Portal>
    );
};
